import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const listFeatureFlags = () =>
  call(websocketFetch, 'list_feature_flags');
